<template>
    <div id="wrapper" class="info-table">
        <!--======================================================
                        Header
                ======================================================-->
        <pages-header></pages-header>

        <second-header></second-header>

        <!--======================================================
                        Main Content
                ======================================================-->
        <div class="mainContainer">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-8">
                            <ul class="nav nav-tabs" id="infoTab" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link active" id="01-tab" data-toggle="tab" href="#tab01" role="tab" aria-controls="01" aria-selected="true">
                                        <span class="day">{{i18n('First floor')}}</span>
                                    </a>
                                </li>
                                <li class="nav-item" v-if="floor === 2">
                                    <a class="nav-link" id="02-tab" data-toggle="tab" href="#tab02" role="tab" aria-controls="02" aria-selected="false">
                                        <span class="day">{{i18n('Second floor')}}</span>
                                    </a>
                                </li>
                            </ul>
                            <div class="base_box table_box tab-content" id="infoTabContent">
                                <div class="tab-pane fade show active scrollable-table-seats" id="tab01" role="tabpanel" aria-labelledby="01-tab">
                                    <div class="dis-table">
                                        <div class="table-cell">
                                            <div class="table-block" v-if="reservedSeatsLoaded">
                                                <table class="seats table-white" v-if="busData.vertical">
                                                    <tr v-for="row in range(firstFloor.minY, firstFloor.maxY)">
                                                        <td v-for="col in range(firstFloor.minX, firstFloor.maxX)"
                                                            :class="getSeatClass(col, row, firstFloor)"
                                                            @click="selectSeat(col,row, firstFloor)"
                                                        >
                                                            {{findSeat(col, row, firstFloor)}}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade scrollable-table-seats" id="tab02" role="tabpanel" aria-labelledby="01-tab" v-if="floor === 2">
                                    <div class="dis-table">
                                        <div class="table-cell">
                                            <div class="table-block" v-if="reservedSeatsLoaded">
                                                <table class="seats table-white" v-if="busData.vertical">
                                                    <tr v-for="row in range(secondFloor.minY, secondFloor.maxY)">
                                                        <td v-for="col in range(secondFloor.minX, secondFloor.maxX)"
                                                            :class="getSeatClass(col, row, secondFloor)"
                                                            @click="selectSeat(col,row, secondFloor)"
                                                        >
                                                            {{findSeat(col, row, secondFloor)}}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="right-sidebar full-height">
                                <p style="font-size: 17px" v-if="leftTime > 0">
                                    {{i18n('Reserved places will be cleared through')}}: {{leftSeconds}}
                                </p>
                                <div class="form-group">
                                    <div class="form-row colorful">
                                        <div class="col-sm-6">
                                            <div class="colorful__number yellow">{{emptySeatsCount}}</div>
                                        </div>
                                        <label class="col-sm-6 colorful__txt">{{i18n('Free')}}</label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-row colorful">
                                        <div class="col-sm-6">
                                            <div class="colorful__number red1">{{bronSeats.length}}</div>
                                        </div>
                                        <label class="col-sm-6 colorful__txt">{{i18n('Busy')}}</label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-row colorful">
                                        <div class="col-sm-6">
                                            <div class="colorful__number red">{{reservedSeatsCount}}</div>
                                        </div>
                                        <label class="col-sm-6 colorful__txt">{{i18n('Reserve')}}</label>
                                    </div>
                                </div>
                                <div class="form-group mb-4">
                                    <div class="form-row colorful">
                                        <div class="col-sm-6">
                                            <div class="colorful__number green">{{selectedSeats.length}}</div>
                                        </div>
                                        <label class="col-sm-6 colorful__txt">{{i18n('Selected')}}</label>
                                    </div>
                                </div>
                                <div class="middle-box"></div>
                                <div class="bottom-box">
                                    <div class="row">
                                        <div class="col-sm-6">{{i18n('Bus station collection')}}:</div>
                                        <div class="col-sm-6 text-right price_txt"><span class="blue-txt">{{taxAmount | moneyFormat}}</span> {{i18n('sum')}}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">{{i18n('Total')}}:</div>
                                        <div class="col-sm-6 text-right price_txt"><span class="blue-txt">{{totalAmount + taxAmount | moneyFormat}}</span> {{i18n('sum')}}</div>
                                    </div>
                                    <button @click="next()" :disabled="selectedSeats.length === 0" class="btn w-100 btn-primary">{{i18n('Next')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div><!--/wrapper-->
</template>

<script>
    import PagesHeader from "../components/PagesHeader";
    import SecondHeader from "../components/SecondHeader";

    export default {
        data() {
            return {
                currentTrip: {},
                busData: {},
                floor: 1,
                firstFloor: [],
                secondFloor: [],
                selectedSeats: [],
                bronSeats: [],
                reservedSeats: [],
                taxes: [],
                totalAmount: 0,
                taxAmount: 0,
                leftTime: 0,
                interval: null,
                reservedSeatsLoaded: false,
            }
        },
        components: {SecondHeader, PagesHeader},
        async created() {
            this.$store.state.from.id = this.$route.params.from;
            this.$store.state.to.id = this.$route.params.to;
            this.$store.commit('setId', new DeviceUUID().get());
            this.selectedSeats = this.$store.state.selectedSeats;
            if (this.selectedSeats.length === 0) {
                this.clearOnProcessSeats();
            }
            this.currentTrip = this.$store.state.selectedTrip;
            if (!this.currentTrip.id) {
                console.log(this.currentTrip);
                this.currentTrip = await this.getTrip();
                this.$store.state.selectedTrip = this.currentTrip;
            }
            this.$store.state.date.date = this.$moment(this.currentTrip.departure_at).format('YYYY-MM-DD');
            if (!this.currentTrip.id) {
                this.$router.push('/');
            }
            this.calculateAllPrice();
            this.getServices();
            if (this.currentTrip.id) {
                this.getReservedSeats();
                this.getBus();
            }
        },
        methods: {
            clearOnProcessSeats() {
                if (this.$store.state.kioskId) {
                    axios.post('/infokiosk/clear-on-process-seats', {id: this.$store.state.kioskId});
                }
            },
            async getTrip() {
                let data = {};
                await axios.post('/infokiosk/get-trip', {
                    from: this.$route.params.from,
                    to: this.$route.params.to,
                    date: this.$route.params.date,
                    id: this.$route.params.id,
                }).then(res => {
                    let trip = res.data.data;
                    let stations = trip.name.split('-');
                    trip.from = stations[0];
                    trip.to = stations[1];
                    data = trip;
                }).catch(err => {
                    this.$router.push({name: 'web'});
                });
                return data;
            },
            getBus() {
                axios.get('/infokiosk/bus/' + this.currentTrip.bus_id)
                    .then(res => {
                        let data = res.data;
                        this.busData.horizontal = JSON.parse(data.bus_model.horizontal_rows_count);
                        this.busData.vertical = JSON.parse(data.bus_model.vertical_rows_count);
                        this.floor = data.bus_model.floor;
                        let i = 1;
                        data.bus_model.bus_model_seats.forEach(item => {
                            if (item.z === 1) {
                                this.firstFloor.push({
                                    id: item.id,
                                    type: item.type,
                                    x: item.x,
                                    y: item.y,
                                    index: i
                                });
                            } else {
                                this.secondFloor.push({
                                    id: item.id,
                                    type: item.type,
                                    x: item.x,
                                    y: item.y,
                                    index: i
                                });
                            }
                            i++;
                        });
                        this.getMinMax(this.firstFloor);
                        this.getMinMax(this.secondFloor);
                        this.getPassengers();
                    })
            },
            getMinMax(seats) {
                if (seats.length > 0) {
                    seats.sort((c, n) => {
                        return c.x - n.x;
                    });
                    seats.minX = seats[0].x;
                    seats.maxX = seats[seats.length - 1].x;
                    seats.sort((c, n) => {
                        return c.y - n.y;
                    });
                    seats.minY = seats[0].y;
                    seats.maxY = seats[seats.length - 1].y;
                }
            },
            getReservedSeats() {
                axios.get('/infokiosk/reserved-seats/' + this.currentTrip.id)
                    .then(res => {
                        if (res.data.data) {
                            this.reservedSeats = res.data.data.seats;
                            this.leftTime = res.data.data.seconds;
                            if (this.leftTime > 0) {
                                this.interval = setInterval(() => {
                                    this.leftTime--;
                                }, 1000);
                            }
                        }
                        this.reservedSeatsLoaded = true;
                    });
            },
            getPassengers() {
                axios.get('/infokiosk/passengers/' + this.currentTrip.id)
                    .then(res => {
                        res.data.forEach(item => {
                            let seat = this.firstFloor.find(fl => item.seat_number === fl.index);
                            if (!seat) {
                                seat = this.secondFloor.find(fl => item.seat_number === fl.index);
                            }
                            this.bronSeats.push(seat);
                            this.$forceUpdate();
                        })
                    })
            },
            getServices() {
                axios.get('/infokiosk/services')
                    .then(res => {
                        this.taxes = res.data.data;
                        this.$store.state.taxes = this.taxes;
                    });
            },
            findSeat(x, y, seats) {
                let seat = seats.find(item => item.x === x && item.y === y);
                return seat ? seat.index : '';
            },
            getSeatClass(x, y, seats) {
                let seat = seats.find(item => item.x === x && item.y === y);
                if (!seat) {
                    return '';
                }
                let selected = this.selectedSeats.find(item => item.id === seat.id);
                if (selected) {
                    return 'green';
                }
                let bron = this.bronSeats.indexOf(seat);
                if (bron >= 0)
                    return 'red1';
                let reserved = this.reservedSeats.find(item => item === seat.index);
                if (reserved > 0) {
                    return 'red';
                }
                return 'yellow';
            },
            async selectSeat(x, y, seats) {
                let seat = seats.find(item => item.x === x && item.y === y);
                if (seat) {
                    let exist = this.selectedSeats.findIndex(item => item.id === seat.id);
                    if (exist >= 0) {
                        this.selectedSeats.splice(exist, 1);
                        this.calculateAllPrice();
                        await this.isSeatOnProcess(seat);
                        return;
                    }
                    let bron = this.bronSeats.indexOf(seat);
                    if (bron >= 0) {
                        return;
                    }
                    let reserved = this.reservedSeats.find(item => item === seat.index);
                    if (reserved > 0) {
                        return;
                    }
                    let status = await this.isSeatOnProcess(seat);
                    if (status) {
                        alert(this.i18n('This seat is selected by other user'));
                        return;
                    }
                    this.selectedSeats.push(seat);

                    // make array of selectedSeats objects unique
                    this.selectedSeats = Array.from(new Set(this.selectedSeats.map(s => s.id)))
                        .map(id => {
                            return this.selectedSeats.find(s => s.id === id);
                        });
                }
                this.calculateAllPrice();
            },
            async isSeatOnProcess(seat) {
                let status = true;
                await axios.post('/infokiosk/on-process-seat', {
                    id: this.$store.state.kioskId,
                    index: seat.index,
                    trip_id: this.currentTrip.id
                }).then(({data}) => {
                    status = data.data.on_process;
                });

                return status;
            },
            calculateAllPrice() {
                let price = this.currentTrip.price;
                this.totalAmount = price * this.selectedSeats.length;
                let tax = 0;
                this.taxes.forEach(item => {
                    tax += item.price;
                });
                this.taxAmount = tax * this.selectedSeats.length;
                this.$store.state.allPrice = this.totalAmount + this.taxAmount;
            },
            range(min, max) {
                let array = [],
                    j = 0;
                for (let i = min; i <= max; i++) {
                    array[j] = i;
                    j++;
                }
                return array;
            },
            next() {
                this.$store.state.selectedSeats = this.selectedSeats;
                this.$router.push({name: 'web-data'});
            },
            // async isSeatOnProcess(seat) {
            //     await axios.post('/infokiosk/on-process-seat', {trip_id})
            // }
        },
        filters: {
            asTime(val) {
                let hour = Math.floor(val / 60 / 60);
                let min = Math.floor(val / 60 % 60);
                return hour + ' ч. ' + min + ' м.'
                // return val
            },
            moneyFormat(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
            }
        },
        computed: {
            leftSeconds: function () {
                let time = this.leftTime;
                if (this.leftTime > 0) {
                    let hour = parseInt(time / 3600);
                    let min = parseInt((time % 3600) / 60);
                    let sec = parseInt(time % 60);
                    return hour + ' ч. ' + min + ' м. ' + sec + ' с.';
                }
            },
            emptySeatsCount: function () {
                return this.firstFloor.length + this.secondFloor.length - this.bronSeats.length;
            },
            reservedSeatsCount: function () {
                let allSeats = this.firstFloor.length + this.secondFloor.length;
                return this.reservedSeats.length > allSeats ? allSeats : this.reservedSeats.length;
            }
        },
        watch: {
            leftTime: function (val) {
                if (val === 0) {
                    this.getReservedSeats();
                    clearInterval(this.interval);
                }
            }
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 767px) {
        .scrollable-table-seats {
            overflow: scroll;
        }
    }

    #infoTabContent {
        min-height: 0;
    }

    #infoTabContent .tab-pane {
        min-height: 0;
    }

    #infoTabContent .table-cell {
        height: 400px;
    }
</style>
